import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NextArrow from 'react-icons/lib/md/chevron-right';
import PrevArrow from 'react-icons/lib/md/chevron-left';
import CarouselNavButton from './CarouselNavButton';
import PureSlider from './PureSlider';

import './carousel.less';

class Carousel extends Component {
	constructor() {
		super();

		this.state = {
			currentIndex: 0
		}

		this.next = this.next.bind(this);
		this.prev = this.prev.bind(this);
		this.updateIndex = this.updateIndex.bind(this);
		this.sliderRef = this.sliderRef.bind(this);
	}

	shouldShowArrows(slideCount) {
		return (this.props.children.length > slideCount);
	}

	next() {
		this.slider.slickNext();
	}

	prev() {
		this.slider.slickPrev();
	}

	sliderRef(el) {
		this.slider = el;
	}

	updateIndex(next) {
		this.setState({
			currentIndex: next
		}, () => {
			if (this.props.reportUpdate) {
				this.props.reportUpdate(this.state.currentIndex);
			}
		});
	}

	isPrevDisabled() {
		return this.state.currentIndex === 0;
	}

	isNextDisabled(slideCount) {
		return (this.state.currentIndex + slideCount) >= this.props.children.length;
	}

	getSlidesToShowCount() {
		let calculated = this.calculateSlidesToShow(this.props.width, this.props.itemWidth, this.props.navButtonWidth, this.props.minMargin);

		if (this.props.slidesToShow && this.props.slidesToShow > 0) {
			return Math.min(this.props.slidesToShow, calculated);
		}
		else {
			return calculated;
		}
	}

	/**
	 * Calculates the number of slides this Carousel should display.
	 *
	 * Formula is n=(w-2b)/(c + p)
	 * w is the width of the carousel,
	 * b is the width of the nav buttons
	 * c is the width of the items displayed in the carousel
	 * p is the minimum margin between items in the carousel
	 * for this implementation p is 10.
	 *
	 * @param {number} width the width of the carousel
	 * @param {number} itemWidth the width of the items displayed in the carousel
	 * @param {number} navButtonWidth the width of the nav buttons
	 * @param {number} minMargin the minimum margin between items in the carousel
	 * @returns {number} The number of slides the Carousel should display based on it's current size.
	 */
	calculateSlidesToShow(width, itemWidth, navButtonWidth, minMargin) {
		const radix = 10;

		width = parseInt(width, radix);
		itemWidth = parseInt(itemWidth, radix);
		navButtonWidth = parseInt(navButtonWidth, radix);

		const numberOfSlidesToShow = Math.max(1, Math.floor((width - navButtonWidth * 2) / (itemWidth + minMargin)));

		return numberOfSlidesToShow;
	}

	render() {
		let { settings, width, navButtonWidth, marginTop, marginBottom } = this.props;
		const slideCount = this.getSlidesToShowCount();
		settings = Object.assign({}, settings, { slidesToShow: slideCount, slidesToScroll: slideCount });
		let showNav = this.shouldShowArrows(slideCount);

		return (
			<div className="carousel" style={{ width, marginTop, marginBottom }}>
				{showNav &&
					<CarouselNavButton disabled={this.isPrevDisabled()} onClick={this.prev}>
						<PrevArrow className="carousel-nav-icon" style={{ width: `${navButtonWidth}px` }} />
					</CarouselNavButton>
				}
				<PureSlider {...settings} updateIndex={this.updateIndex} sliderRef={this.sliderRef}>
					{this.props.children}
				</PureSlider>
				{showNav &&
					<CarouselNavButton disabled={this.isNextDisabled(slideCount)} onClick={this.next}>
						<NextArrow className="carousel-nav-icon" style={{ width: `${navButtonWidth}px` }} />
					</CarouselNavButton>
				}
			</div>
		);
	}
}

Carousel.defaultProps = {
	settings: {
		infinite: false,
		speed: 400,
		lazyLoad: true,
		arrows: false,
	},
	minMargin: 1, //set minMargin to accomodate 4 bookjackets displaying on smaller screens
	navButtonWidth: 42
};

Carousel.propTypes = {
	children: PropTypes.arrayOf(PropTypes.object).isRequired,
	itemWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	minMargin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	navButtonWidth: PropTypes.number,
	settings: PropTypes.object,
	width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	reportUpdate: PropTypes.func,
	slidesToShow: PropTypes.number
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/react/views/carousel/Carousel.jsx